module.exports = __webpack_public_path__ + "static/wallpaper2-50ab8e7c6285c1faf7b9622e76651892.jpg";